import { ReactNode } from 'react'

import { Link } from 'react-router-dom'

import { Flex, Icon } from 'components/core'
import { IconListType } from 'components/core/Icon/constants'
import { categoryPerformanceDetailUrl } from 'routing/urls'

import * as styles from './CategoryTitleCell.module.scss'

interface CategoryTitleCellProps {
    value: ReactNode
    categoryId?: string
    marketplace?: string
    dateRange?: string[]
    onClick?: () => void
}

export function CategoryTitleCell({
    value,
    categoryId,
    marketplace,
    dateRange,
    onClick,
}: CategoryTitleCellProps): ReactNode {
    const marketplaceUpperCase = marketplace?.toUpperCase()
    if (!categoryId || categoryId === 'Unknown') {
        return value
    }

    const url = categoryPerformanceDetailUrl(categoryId, {
        countryCode: marketplaceUpperCase,
        dateRange,
    })

    return (
        <Flex gap={6}>
            {marketplaceUpperCase && (
                <Icon
                    name={marketplaceUpperCase as IconListType}
                    width={16}
                    height={12}
                    style={{ borderRadius: 2 }}
                />
            )}
            <Link
                to={url}
                className={styles['category-title-truncate']}
                onClick={onClick}
            >
                {value}
            </Link>
        </Flex>
    )
}
